module.exports = __webpack_public_path__ + "img/files_icon.d7b0527b.svg";